import React, { useEffect, useState } from 'react';
import { FaWhatsapp, FaExternalLinkAlt, FaCog } from 'react-icons/fa';
import api from '../api';
import CRMChannelInbox from './CRMChannelInbox';
export function whatsappNumber(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length === 10 || digits.length === 11 ? '55' + digits : /^\d{12,15}$/.test(digits) ? digits : '';
}
export default function CustomerWhatsApp({ customer, onConfigure }) {
  const [connection, setConnection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.get('/crm/channels/connections').then(({ data }) => {
      if (active) setConnection((data?.connections || []).find(item => item.provider === 'whatsapp') || null);
    }).catch(failure => { if (active) setError(failure?.response?.data?.error || 'Não foi possível acessar o WhatsApp da empresa.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const contacts = (customer.phones?.length ? customer.phones : [{ value: customer.phone }]).map(item => ({ number: whatsappNumber(item.value || item), label: item.label })).filter(item => item.number);
  const unique = contacts.filter((item, index) => contacts.findIndex(other => other.number === item.number) === index);
  return <div className="space-y-4">
    {loading && <p role="status" className="text-sm text-slate-500">Consultando o canal da empresa…</p>}
    {error && <p role="alert" className="customer-inline-error">{error}</p>}
    {!loading && !error && <div className="customer-whatsapp-status"><FaWhatsapp/><span>{connection?.connected ? connection.accountName || 'WhatsApp da empresa conectado' : 'WhatsApp da empresa desconectado'}</span>
      {onConfigure && <button type="button" className="customer-button-secondary" onClick={onConfigure}><FaCog/> Canais do CRM</button>}
    </div>}
    {connection?.connected && <CRMChannelInbox key={customer.id} customerId={customer.id} provider="whatsapp" compact/>}
    {unique.length > 0 && <div className="customer-web-contacts">{unique.map(contact => <a key={contact.number} href={'https://wa.me/' + contact.number} target="_blank" rel="noopener noreferrer" className="customer-button-secondary"><FaExternalLinkAlt/> WhatsApp Web{contact.label ? ' · ' + contact.label : unique.length > 1 ? ' · ' + contact.number : ''}</a>)}<span>Usa a sessão do WhatsApp aberta no navegador.</span></div>}
    {!loading && !unique.length && !connection?.connected && <p className="text-sm text-slate-500">Adicione um telefone com DDD na ficha do cliente.</p>}
  </div>;
}
